import { useQuery } from 'react-query';
import axios from 'axios';
import {
  IPackage,
  IRequestAQuoteData,
  ITaxonomy,
} from 'interfaces/requestAQuote';

export function useLoadRAQData(queryKey: string) {
  return useQuery<IRequestAQuoteData, Error>(
    queryKey,
    async () => {
      let response;
      response = await axios.get(queryKey);

      response.data.taxonomy = response.data.taxonomy.map((tax: ITaxonomy) => {
        tax.vehicles.forEach((vehicle) => {
          const undecidedValue: IPackage = {
            vehicleModel: 'Undecided',
            packageName: 'Undecided',
            packageDescription: '',
            packageImageUrl: vehicle.defaultVehicleImage,
            packageImageAlt: vehicle.defaultVehicleImageAlt,
          };
          vehicle.packages?.push(undecidedValue);
        });
        return tax;
      });
      return response.data as IRequestAQuoteData;
    },
    {
      staleTime: Infinity, //adding staleTime to avoid re fetching the endpoint each time the user refocus the page.
    }
  );
}
